import { render, staticRenderFns } from "./ChecklistRecordSkeleton.vue?vue&type=template&id=87325b18"
import script from "./ChecklistRecordSkeleton.vue?vue&type=script&lang=js"
export * from "./ChecklistRecordSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ChecklistRecordSkeleton.vue?vue&type=style&index=0&id=87325b18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports